import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';

export const useInstructor = () => {
  const { user } = useAuth();

  const { data: isInstructor, isLoading, error } = useQuery({
    queryKey: ['instructor-status', user?.id],
    queryFn: async () => {
      if (!user?.id) return false;

      const { data, error } = await supabase
        .from('profiles')
        .select('is_instructor')
        .eq('id', user.id)
        .single();

      if (error) {
        console.error('Error fetching instructor status:', error);
        return false;
      }

      return data?.is_instructor || false;
    },
    enabled: !!user?.id,
  });

  return {
    isInstructor: isInstructor || false,
    isLoading,
    error,
  };
};
